module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/mena-kazerounian-dae1bd3add68533f970134542545eef5.jpg";